<template>
  <div>
    <a @click="fnShowModal()" class="p-2"
      ><i class="far fa-edit text-primary"></i
    ></a>

    <b-modal ref="userModal" hide-footer title="Car Category - update">
      <div class="d-block">
        <form>
          <div class="form-group">
            <input
              type="text"
              class="form-control"
              placeholder=" "
              autocomplete="off_name"
              v-model="categoryData.name"
            />
            <label class="floatingLabel" for="name">Name</label>
            <div class="invalid-feedback" v-if="errors.name">
              {{ errors.name[0] }}
            </div>
          </div>
          <div class="form-group">
            <textarea
              type="text"
              class="form-control"
              placeholder=" "
              autocomplete="off_description"
              rows="5"
              v-model="categoryData.description"
            />
            <label class="floatingLabel" for="description">Description</label>
            <div class="invalid-feedback" v-if="errors.description">
              {{ errors.description[0] }}
            </div>
          </div>
          <div class="form-group">
            <div class="d-flex flex-row">
              <label class="pr500" for="status">Status</label>
              <b-form-checkbox
                switch
                id="checkbox-1"
                name="checkbox-1"
                value="1"
                unchecked-value="0"
                v-model="categoryData.status"
              >
              </b-form-checkbox>
            </div>
          </div>
          <hr />
          <div class="text-right">
            <button
              type="button"
              class="btn btn-dark btn-sm mr-2"
              @click="hideModal"
            >
              Cancel
            </button>
            <button
              type="button"
              @click="fnUpdate"
              class="btn btn-primary btn-sm"
            >
              <b-spinner small v-if="is_spinActive"></b-spinner>
              Save
            </button>
          </div>
        </form>
      </div>
    </b-modal>
  </div>
</template>
<script>
import { mapGetters, mapActions } from 'vuex'
import * as messageService from '../../services/message.service'
import * as carCategoryService from '../../services/carCategory.service'
export default {
  name: 'ModelCarCategoryEdit',
  props: ['propsData'],
  components: {},
  data() {
    return {
      errors: {},
      categoryData: {
        id: -1,
        name: '',
        description: '',
        status: 0
      },

      is_spinActive: false
    }
  },
  computed: {
    ...mapGetters(['getCarCategoryPaginate'])
  },
  methods: {
    ...mapActions(['fetchCarCategoryPaginate']),
    fnShowModal() {
      this.showModal()
    },
    hideModal() {
      this.$refs.userModal.hide()
    },
    showModal() {
      Object.assign(this.categoryData, this.propsData)
      this.$refs.userModal.show()
    },

    fnUpdate: async function () {
      this.is_spinActive = true

      try {
        const response = await carCategoryService.update(
          this.propsData.id,
          this.categoryData
        )
        this.fetchCarCategoryPaginate(this.getCarCategoryPaginate)
        this.hideModal()
        messageService.fnSweetAlertSuccessToast(
          'Car Category',
          'Update success'
        )

        this.is_spinActive = false
        this.categoryData.id = -1
        this.categoryData.name = ''
        this.categoryData.description = ''
      } catch (error) {
        switch (error.response.status) {
          case 422:
            this.errors = error.response.data.errors
            break

          case 500:
            messageService.fnSweetAlertErrorToast(
              'Car Category - new',
              error.response.data.message
            )
            break

          default:
            messageService.fnSweetAlertErrorToast(
              'Car Category - new',
              'Something wrong'
            )
            break
        }
        this.is_spinActive = false
      }
    }
  }
}
</script>